export const CACHE_ACTIONS = {
    PERSIST_STORE_CACHE: 'persistStoreCache'
};

export const CACHE_MUTATIONS = {
    SAVE_STORE_CACHE: 'saveStoreCache'
};
